import React, { useState } from 'react';
import styled from 'styled-components';
import InputBox from '../../InputBox';
import Button from '../../Button';
import { useFirebase } from 'react-redux-firebase';

const StyledForgotPasswordForm = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 300px;
  input {
    margin-bottom: 20px;
  }
  button {
    margin-bottom: 10px;
  }

  p {
    color: grey;
    font-size: 14px;
  }
`;

const StyledMsg = styled.div`
  color: ${(props) => props.color};
`;

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [responseMsgObj, setResponseMsgObj] = useState({
    text: '',
    color: 'black'
  });
  const firebase = useFirebase();

  // handle form submit
  const handleSubmit = (event) => {
    event.preventDefault();

    console.log('handle');
    firebase
      .resetPassword(email)
      .then((e) => {
        setResponseMsgObj({ text: 'Email sent', color: 'black' });
      })
      .catch((error) => {
        console.log(error);
        setResponseMsgObj({ text: error.message, color: 'red' });
      });
  };

  return (
    <StyledForgotPasswordForm onSubmit={handleSubmit}>
      <p>Enter your email to reset password</p>
      <InputBox
        name="email"
        placeholder="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button type="submit" text="Send" />
      <StyledMsg color={responseMsgObj.color}>{responseMsgObj.text}</StyledMsg>
    </StyledForgotPasswordForm>
  );
};

export default ForgotPasswordForm;
